module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/cohort-ii-mentors.json
// module id = 668
// module chunks = 1152426024279